
import courseApi from '../../api/course.api'

const state = {}
const getters = {}
const mutations = {}
const actions = {
	// 查询课程
	getMemberCourse(context, params) {
		return courseApi.getMemberCourse(params)
	},
	/**
	 * 根据videoId获取对应课程信息
	 * @param {Object} params
	 */
	getMemberCourseById(context, params) {
		return courseApi.getMemberCourseById(params)
	},
	/**
	 * 更新视频信息
	 * @param {Object} params
	 */
	updateCourseInfo(context, params) {
		return courseApi.updateCourseInfo(params)
	},
	/**
	 * 获取视频分类
	 */
	getCourseType() {
		return courseApi.getCourseType()
	},
	/**
	 * 保存播放次数
	 */
	savePlayCount(context, params) {
		return courseApi.savePlayCount(params)
	},
	/**
	 * 添加学习人数次数
	 */
	saveUserCount(context, params) {
		return courseApi.saveUserCount(params)
	},
	updateKnowed(context, params) {
		return courseApi.updateKnowed(params)
	}
}

export default { state, getters, mutations, actions, namespaced: true }
